import { EEnvCountry } from '../env.types';

export const getSupportedCountryCodeOrFallback = (
  inputCountry: string
): EEnvCountry => {
  if (inputCountry in EEnvCountry) return EEnvCountry[inputCountry];

  return EEnvCountry.FR;
};
